export default __webpack_public_path__ + "static/Unassembled_Exo-Mek-fdc4849276f03dc308e376075caccad6.png";